import { useState } from 'react';
import ImageGallery from 'react-image-gallery';

// import diTrento1 from '../../assets/img/diTrento1.jpg'
// import f8 from '../../assets/img/f8.jpg'
// import f4 from '../../assets/img/f4.jpg'
// import diTrento4 from '../../assets/img/diTrento4.jpg'
// import diTrento5 from '../../assets/img/diTrento5.jpg'
// import diTrento7 from '../../assets/img/diTrento7.jpg'
// import diTrento8 from '../../assets/img/diTrento8.jpg'
// import diTrento9 from '../../assets/img/4456.jpg'
// import diTrento10 from '../../assets/img/diTrento10.jpg'

import h2a1 from '../../assets/img/h2a1.jpg'
import h2a2 from '../../assets/img/h2a2.jpg'
import h2a3 from '../../assets/img/h2a3.jpg'
import h2a4 from '../../assets/img/h2a4.jpg'

import lilian1 from '../../assets/img/lilian1.jpg'
import lilian2 from '../../assets/img/lilian2.jpg'
import lilian3 from '../../assets/img/lilian3.jpg'
import lilian4 from '../../assets/img/lilian4.jpg'

import ja1 from '../../assets/img/ja1.jpg'
import ja2 from '../../assets/img/ja2.jpg'
import ja3 from '../../assets/img/ja3.jpg'
import ja4 from '../../assets/img/ja4.jpg'

import bu1 from '../../assets/img/bu1.jpg'
import bu2 from '../../assets/img/bu2.jpg'
import bu3 from '../../assets/img/bu3.jpg'
import bu4 from '../../assets/img/bu4.jpg'

import ro1 from '../../assets/img/ro1.jpg'
import ro2 from '../../assets/img/ro2.jpg'
import ro3 from '../../assets/img/ro3.jpg'
import ro4 from '../../assets/img/ro4.jpg'

import sa1 from '../../assets/img/sa1.jpg'
import sa2 from '../../assets/img/sa2.jpg'
import sa3 from '../../assets/img/sa3.jpg'
import sa4 from '../../assets/img/sa4.jpg'

import ira1 from '../../assets/img/ira1.jpg'
import ira2 from '../../assets/img/ira2.jpg'
import ira3 from '../../assets/img/ira3.jpg'
import ira4 from '../../assets/img/ira4.jpg'

import f14 from '../../assets/img/f14.jpg'
import f9 from '../../assets/img/f9.jpg'
import ide3 from '../../assets/img/ide3.jpg'
import f13 from '../../assets/img/f13.jpg'

import ate0 from '../../assets/img/ate0.png'
import ate1 from '../../assets/img/ate1.png'
import ate2 from '../../assets/img/ate2.png'
import ate3 from '../../assets/img/ate3.png'
import ate4 from '../../assets/img/ate4.png'

import lofty from '../../assets/img/lofty.jpg'
import partiuFilmes from '../../assets/img/partiuFilmes.png'

import insta from '../../assets/img/icons/instagram-icon.png'
import whats from '../../assets/img/icons/whatsapp-icon.png'
import youtube from '../../assets/img/icons/youtube-icon.png'
import site from '../../assets/img/icons/site.png'
import { Container, Content } from './styles';
import { TiArrowForward } from 'react-icons/ti';

export function Caterers() {
    const [fornecedor, setFornecedor] = useState('Banda');

    // const imagesDiTrento = [
    //     {
    //         original: diTrento1,
    //         thumbnail: diTrento1,
    //     },
    //     {
    //         original: diTrento10,
    //         thumbnail: diTrento10,
    //     },
    //     {
    //         original: diTrento9,
    //         thumbnail: diTrento9,
    //     },
    //     {
    //         original: f8,
    //         thumbnail: f8,
    //     },
    //     {
    //         original: f4,
    //         thumbnail: f4,
    //     },
    //     {
    //         original: diTrento4,
    //         thumbnail: diTrento4,
    //     },
    //     {
    //         original: diTrento5,
    //         thumbnail: diTrento5,
    //     },
    //     {
    //         original: diTrento7,
    //         thumbnail: diTrento7,
    //     },
    //     {
    //         original: diTrento8,
    //         thumbnail: diTrento8,
    //     }
    // ];

    const imagesH2A = [
        {
            original: h2a1,
            thumbnail: h2a1,
        },
        {
            original: h2a2,
            thumbnail: h2a2,
        },
        {
            original: h2a3,
            thumbnail: h2a3,
        },
        {
            original: h2a4,
            thumbnail: h2a4,
        },
    ];

    const imagesLilian = [
        {
            original: lilian1,
            thumbnail: lilian1,
        },
        {
            original: lilian2,
            thumbnail: lilian2,
        },
        {
            original: lilian3,
            thumbnail: lilian3,
        },
        {
            original: lilian4,
            thumbnail: lilian4,
        },
    ];

    const imagesJackson = [
        {
            original: ja1,
            thumbnail: ja1,
        },
        {
            original: ja2,
            thumbnail: ja2,
        },
        {
            original: ja3,
            thumbnail: ja3,
        },
        {
            original: ja4,
            thumbnail: ja4,
        },
    ];

    const imagesBuffet = [
        {
            original: bu1,
            thumbnail: bu1,
        },
        {
            original: bu2,
            thumbnail: bu2,
        },
        {
            original: bu3,
            thumbnail: bu3,
        },
        {
            original: bu4,
            thumbnail: bu4,
        },
    ];

    const imagesBolos = [
        {
            original: ro1,
            thumbnail: ro1,
        },
        {
            original: ro2,
            thumbnail: ro2,
        },
        {
            original: ro3,
            thumbnail: ro3,
        },
        {
            original: ro4,
            thumbnail: ro4,
        },
    ];

    const imagesDelicious = [
        {
            original: sa1,
            thumbnail: sa1,
        },
        {
            original: sa2,
            thumbnail: sa2,
        },
        {
            original: sa3,
            thumbnail: sa3,
        },
        {
            original: sa4,
            thumbnail: sa4,
        },
    ];

    const imagesCoqueteis = [
        {
            original: ira1,
            thumbnail: ira1,
        },
        {
            original: ira2,
            thumbnail: ira2,
        },
        {
            original: ira3,
            thumbnail: ira3,
        },
        {
            original: ira4,
            thumbnail: ira4,
        },
    ];

    const imagesFotos = [
        {
            original: f14,
            thumbnail: f14,
        },
        {
            original: f13,
            thumbnail: f13,
        },
        {
            original: ide3,
            thumbnail: ide3,
        },
        {
            original: f9,
            thumbnail: f9,
        },
    ];

    const imagesAtelie = [        
        {
            original: ate1,
            thumbnail: ate1,
        },
        {
            original: ate2,
            thumbnail: ate2,
        },
        {
            original: ate3,
            thumbnail: ate3,
        },
        {
            original: ate4,
            thumbnail: ate4,
        },
        {
            original: ate0,
            thumbnail: ate0,
        }
    ];

    function handleClick(value) {
        setFornecedor(value);
    }

    return (
        <Container id="fornecedores">
            <h1>Fornecedores</h1>
            <Content>
                <div className='caterers'>
                    <ul>
                        {/* <li className={fornecedor === 'Espaço' ? 'active' : ""} onClick={() => handleClick('Espaço')}><TiArrowForward />Espaço</li> */}
                        <li className={fornecedor === 'Banda' ? 'active' : ""} onClick={() => handleClick('Banda')}><TiArrowForward />Banda</li>
                        <li className={fornecedor === 'Decoração' ? 'active' : ""} onClick={() => handleClick('Decoração')}><TiArrowForward />Decoração</li>
                        <li className={fornecedor === 'Iluminação' ? 'active' : ""} onClick={() => handleClick('Iluminação')}><TiArrowForward />Iluminação</li>
                        <li className={fornecedor === 'Cerimonial' ? 'active' : ""} onClick={() => handleClick('Cerimonial')}><TiArrowForward />Cerimonial</li>
                        <li className={fornecedor === 'Buffet' ? 'active' : ""} onClick={() => handleClick('Buffet')}><TiArrowForward />Buffet</li>
                        <li className={fornecedor === 'Doces' ? 'active' : ""} onClick={() => handleClick('Doces')}><TiArrowForward />Doces</li>
                        <li className={fornecedor === 'Bolo' ? 'active' : ""} onClick={() => handleClick('Bolo')}><TiArrowForward />Bolo</li>
                        <li className={fornecedor === 'Drinks e Coquetéis' ? 'active' : ""} onClick={() => handleClick('Drinks e Coquetéis')}><TiArrowForward />Drinks e Coquetéis</li>
                        <li className={fornecedor === 'Fotografia' ? 'active' : ""} onClick={() => handleClick('Fotografia')}><TiArrowForward />Fotografia</li>
                        <li className={fornecedor === 'Video' ? 'active' : ""} onClick={() => handleClick('Video')}><TiArrowForward />Vídeo</li>
                        <li className={fornecedor === 'Lembrancinhas' ? 'active' : ""} onClick={() => handleClick('Lembrancinhas')}><TiArrowForward />Lembrancinhas</li>
                    </ul>
                </div>
                <div className="details">  
                    {/* {fornecedor === 'Espaço' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Espaço Di Trento</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/espacoditrento/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584994627808&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                    <li className='redes'><a href="https://www.youtube.com/channel/UCDm92gwkAFr2kIxdJwxqrGg" target="_blank" rel="noreferrer"><img src={youtube} style={{ width: '37px' }} alt="Youtube" /></a></li>
                                </ul>
                                <p>Não conhecíamos o espaço Di Trento. Quando Wellton encontrou esse lugar no instagram, ficamos encantados! Quando conhecemos pessoalmente vimos o quanto esse lugar é o mais lindo de Natal para nós. Deus nos abençoou em podermos casar nesse lugar. Nosso pré-wedding foi feito lá, amamos a atmosfera que há nesse espaço.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesDiTrento} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}                                      */}
                    {fornecedor === 'Banda' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Orquestra e Banda H2A</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/bandah2a/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584988043930&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                    <li className='redes'><a href="https://www.youtube.com/user/bandah2a/featured" target="_blank" rel="noreferrer"><img src={youtube} style={{ width: '37px' }} alt="Youtube" /></a></li>
                                </ul>
                                <p>Ter uma banda animada que tocasse de tudo era nossa prioridade. Queríamos uma banda que atingisse todos os públicos na nossa festa. Ao conhecer a banda H2A tivemos essa certeza. O que mais nos chamou atenção foi os inúmeros elogios sobre eles, sempre ouvimos das noivas que as expectativas são superadas pois a banda anima e não deixa ninguém parado. Herbert estar sempre à disposição para tirar todas as dúvidas do casal e ajudar no que for preciso. Temos a certeza que com a banda H2A a animação está garantida.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesH2A} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Decoração' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Lilian Pacheco Flores e Festas</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/lilianpachecofloresefestas/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584998494957&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Desde que decidimos casar comecei a pesquisar a decoração e por incrível que pareça simplesmente todas as decorações que chamavam minha atenção e trazia aquela sensação: É ISSO QUE QUERO, era com Lilian Pacheco. Era incrível que ao ver fotos de casamentos eu já consigo com facilidade identificar quando é a decoração da Lilian. Costumo dizer que tenho o "chama" para a decoração de Lilian e fiz questão de ser ela. Sempre soube da sua fama de atenciosa, prestativa, em trabalhar com amor e principalmente sonhar com os noivos.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesLilian} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Iluminação' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Jackson Iluminações</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/jacksoniluminacao/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584987128939&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Jackson é um cara <em>iluminado</em> com o coração gigante. Logo quando entrei em contato com ele, pude perceber o seu cuidado com os clientes em explicar tudo o que um casamento necessita em iluminação. Jackson fez questão de ir ao local conosco para analisar o espaço e preparar uma melhor estrutura de iluminação para deixar o ambiente ainda mais lindo. Nos passou muita confiança e segurança no seu trabalho.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesJackson} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}                    
                    {fornecedor === 'Cerimonial' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Lofty Assessoria e Cerimonial</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/loftycerimonial/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584991365199&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Nosso primeiro contrato fechado foi com a Lofty Cerimonial, foi um dos nossos melhores contratos fechados. Já conhecíamos Aline Gurgel, conhecida como Bibi na nossa igreja e nos auxiliou no curso de noivos. Grande carisma e afeto temos por ela. Nih Araújo é conhecida como a desenrolada, também a conhecemos na nossa igreja. As duas fazem tudo com excelência e amor. Dessa vez, a conhecemos profissionalmente com uma reunião on-line e nos trouxeram grande segurança em entregar esse grande sonho nas mãos delas. São atenciosas, sempre nos mostraram a realidade, sabem ter uma excelente comunicação e realmente sonham com os noivos.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <img src={lofty} className='photoOnly' alt="Lofty Assessoria e Cerimonial" loading="lazy" />
                            </div>
                        </div>
                    )} 
                    {fornecedor === 'Buffet' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Buffet San Valle</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/buffetsanvalle/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584996633160&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Nossa experiência com o Buffet San Valle foi uma grande alegria para nós. Estávamos para fechar com outro buffet, um casal de amigos noivos precisou cancelar a festa deles devido a pandemia e repassou o contrato deles para nós. Abençoamos eles e fomos abençoados! Quando conhecemos Cecília nos simpatizamos demais com seu jeito e principalmente sua honestidade e sinceridade (o que conta muito para nós). Além disso, o Buffet San Valle nos ganhou pela boca, pois é muito saboroso. Somos fãs das comidas mais tradicionais e bem servida. Além da grande variedade gastronômica que oferecem.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesBuffet} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Doces' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Doceria Delicious</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/doceriadelicious_/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584994114639&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Samuel é um grande amigo nosso do coração, além de ser o amigo do time do noivo. Sempre fomos fã dos doces impecáveis que ele faz, tem uma pegada grande de excelência e amor. Sabe realmente transmitir para o sabor o que desejamos e gostamos. É bastante comprometido e traz segurança. Tinha que ser ele!</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesDelicious} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Bolo' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Robinson Cake Designer</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/robinsoncamarabolos/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584996682222&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Robinson Câmara Cake Designer faz um dos bolos mais lindos que já vimos e o sabor, textura da massa nos ganhou pela boca. É honesto, soube nos direcionar para a melhor escolha, trabalha com muita dedicação, responsabilidade e comprometimento. Uma das partes mais importantes de um casamento que atende tanto ao visual como sabor precisa trazer segurança e credibilidade. Ficamos felizes com a nossa escolha.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesBolos} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Drinks e Coquetéis' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Iranaldo Coquetéis</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/iranaldo_coqueteis/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584987717268&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Já conhecia de ouvir falar e tinha curiosidade de degustar seus drinks. Conheci o Iranaldo em um casamento que fui e tive a oportunidade de experimentar um pouco de cada drink que ele prepara, eu simplesmente amei!!! Além de preparar boas bebidas, Iranaldo é muito simpático e atencioso com todos. Logo em seguida peguei o contato dele e fizemos amizade de conversar sobre outras coisas do casamento e me tirou todas as dúvidas. Renata está no grupo das noivas e quem conhece indica ele de olhos fechados.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesCoqueteis} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Fotografia' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Ideia Fotografia</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/ideiafotografia/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584987261772&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>Ideia Fotografia tem uma pegada especial de romantismo, é um casal engraçado e cativante. São responsáveis com o trabalho e o sonho do casal. Sempre ouvi elogios deles e isso nos aumentou o desejo de fechar com eles. Sabemos que tirar fotos é cansativo, com o Ideia Fotografia o nosso pré-wedding foi engraçado, divertido e romântico.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesFotos} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Video' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Partiu Filmes</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/partiufilmes/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584992196636&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                    <li className='redes'><a href="https://www.youtube.com/c/PartiuFilmes" target="_blank" rel="noreferrer"><img src={youtube} style={{ width: '37px' }} alt="Youtube" /></a></li>
                                    <li className='redes'><a href="https://www.partiufilmes.com.br/" target="_blank" rel="noreferrer"><img src={site} style={{ width: '30px' }} alt="Site" /></a></li>
                                </ul>
                                <p>
                                    Partiu Filmes nos encantou desde que vimos seu trabalho no instagram e por eles trabalharem com drone, sempre achamos o máximo essa tecnologia e como o espaço que vamos casar é incrivelmente lindo nada como um drone para registrar esse grande momento em todos os ângulos. 
                                    Rayane é uma pessoa bastante comunicativa, disponível e negociável. Nos deu bastante dicas e auxiliou com honestidade a forma que vamos registrar esse grande sonho!
                                </p>
                            </div>
                            <div className="fotos-fornecedores">
                                <img src={partiuFilmes} className='photoOnlyPartiu' alt="Partiu Filmes" loading="lazy" />
                            </div>
                        </div>
                    )}
                    {fornecedor === 'Lembrancinhas' && (
                        <div className='row'>
                            <div className='description'>
                                <h2>Ateliê Bolsas</h2>
                                <ul>
                                    <li className='redes'><a href="https://www.instagram.com/ateliebolsasrn/" target="_blank" rel="noreferrer"><img src={insta} style={{ width: '30px' }} alt="Instagram" /></a></li>
                                    <li className='redes'><a href="http://api.whatsapp.com/send?1=pt_BR&phone=5584994569774&text=Olá,%20venho%20através%20da%20indicação%20de%20Wellton%20e%20Renata." target="_blank" rel="noreferrer"><img src={whats} style={{ width: '30px' }} alt="Whatsapp" /></a></li>
                                </ul>
                                <p>A lembrancinha (convite) tem um toque especial, foi com grande ajuda da minha sogra (mãe do noivo), proprietária do Ateliê Bolsas RN. Fez as necessaires impecáveis dos nossos pais, padrinhos e time dos noivos, além de pintar e preparar as caixas em MDF que ficaram lindas. Tudo que ela faz é com excelência e capricho.</p>
                            </div>
                            <div className="fotos-fornecedores">
                                <ImageGallery items={imagesAtelie} autoPlay={false} showThumbnails={true} lazyLoad={true} showNav={false} />
                            </div>
                        </div>
                    )}
                </div>
            </Content>
        </Container>
    );
}